import { gql } from '@apollo/client';

export const CREATE_BRANDED_APP_PROMO_CODE_MUTATION = gql`
    mutation CreateBrandedAppPromoCode($input: CreateBrandedAppPromoCodeDTO!) {
        createBrandedAppPromoCode(input: $input) {
            message
        }
    }
`;

export const UPDATE_BRANDED_APP_PROMO_CODE_MUTATION = gql`
    mutation UpdateBrandedAppPromoCode($input: UpdateBrandedAppPromoCodeDTO!) {
        updateBrandedAppPromoCode(input: $input) {
            message
        }
    }
`;

export const CHANGE_BRANDED_APP_PROMO_CODE_STATUS_MUTATION = gql`
    mutation ChangeBrandedAppPromoCodeStatus($input: BrandedAppPromoCodeStatusDTO!) {
        changeBrandedAppPromoCodeStatus(input: $input) {
            message
        }
    }
`;

export const DELETE_BRANDED_APP_PROMO_CODE_MUTATION = gql`
    mutation DeleteBrandedAppPromoCode($input: BrandedAppPromoCodeIdDTO!) {
        deleteBrandedAppPromoCode(input: $input) {
            message
        }
    }
`;
